import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const reasonApi = createApi({
  reducerPath: "reasonApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api/reason" }),
  tagTypes: ["Reason"],
  endpoints: (builder) => ({
    getReasons: builder.query({
      query: (param) => `/?type=${param}`,
      providesTags: ["Reason"],
    })
  }),
});

export const { 
  useGetReasonsQuery
} = reasonApi;